export interface AssetRelationship {
  id: string;
  source_asset_id: string;
  target_asset_id: string;
  relationship_type: RelationshipType;
  description?: string;
  importance_level: ImportanceLevel;
  created_at: string;
  updated_at: string;
  created_by: string;
  client_id: string;
  
  // Relacionamentos para exibição
  source_asset?: {
    id: string;
    nome: string;
    tipo_nome?: string;
    status_operacional?: string;
  };
  target_asset?: {
    id: string;
    nome: string;
    tipo_nome?: string;
    status_operacional?: string;
  };
}

export type RelationshipType = 
  | 'contains'        // Contém
  | 'depends_on'      // Depende de
  | 'connects_to'     // Conecta-se a
  | 'hosts'           // Hospeda
  | 'uses'            // Usa
  | 'manages'         // Gerencia
  | 'monitors'        // Monitora
  | 'backup_of'       // Backup de
  | 'replaces'        // Substitui
  | 'supports'        // Suporta
  | 'part_of';        // Parte de

export type ImportanceLevel = 
  | 'critical'        // Crítico
  | 'high'           // Alto
  | 'medium'         // Médio
  | 'low';           // Baixo

export const RELATIONSHIP_TYPES: Record<RelationshipType, { label: string; description: string; bidirectional?: boolean }> = {
  contains: {
    label: 'Contém',
    description: 'Este ativo contém o ativo relacionado',
  },
  depends_on: {
    label: 'Depende de',
    description: 'Este ativo depende do ativo relacionado para funcionar',
  },
  connects_to: {
    label: 'Conecta-se a',
    description: 'Este ativo está fisicamente conectado ao ativo relacionado',
    bidirectional: true,
  },
  hosts: {
    label: 'Hospeda',
    description: 'Este ativo hospeda ou executa o ativo relacionado',
  },
  uses: {
    label: 'Usa',
    description: 'Este ativo utiliza o ativo relacionado',
  },
  manages: {
    label: 'Gerencia',
    description: 'Este ativo gerencia ou controla o ativo relacionado',
  },
  monitors: {
    label: 'Monitora',
    description: 'Este ativo monitora o ativo relacionado',
  },
  backup_of: {
    label: 'Backup de',
    description: 'Este ativo é um backup do ativo relacionado',
  },
  replaces: {
    label: 'Substitui',
    description: 'Este ativo substitui o ativo relacionado',
  },
  supports: {
    label: 'Suporta',
    description: 'Este ativo fornece suporte ao ativo relacionado',
  },
  part_of: {
    label: 'Parte de',
    description: 'Este ativo é parte do ativo relacionado',
  },
};

export const IMPORTANCE_LEVELS: Record<ImportanceLevel, { label: string; color: string; priority: number }> = {
  critical: {
    label: 'Crítico',
    color: 'red',
    priority: 4,
  },
  high: {
    label: 'Alto',
    color: 'orange',
    priority: 3,
  },
  medium: {
    label: 'Médio',
    color: 'yellow',
    priority: 2,
  },
  low: {
    label: 'Baixo',
    color: 'green',
    priority: 1,
  },
};

export interface AssetRelationshipFormData {
  target_asset_id: string;
  relationship_type: RelationshipType;
  description?: string;
  importance_level: ImportanceLevel;
}

export interface AssetNode {
  id: string;
  name: string;
  type: string;
  icon?: string;
  status: string;
  importance: ImportanceLevel;
  x?: number;
  y?: number;
}

export interface AssetEdge {
  id: string;
  source: string;
  target: string;
  type: RelationshipType;
  importance: ImportanceLevel;
  label: string;
}

export interface AssetGraph {
  nodes: AssetNode[];
  edges: AssetEdge[];
}
